export const getSchoolYearsList = (firstYear, secondYear, reverse) => {
  const years = []
  for (let i = firstYear; i <= secondYear; i++) {
    const year = `${i}-${i + 1}`
    years.push(year)
  }
  return reverse ? years.reverse() : years
}

export function getCurrentAcademicYear() {
  const now = new Date();
  const yearStart = now.getFullYear();
  if (now.getMonth() < 7) {
      return `${yearStart - 1}-${yearStart}`;
  } else {
      return `${yearStart}-${yearStart + 1}`;
  }
}

export const getFormParams = (form_) => {
  const year = form_.year.split('-')[1]
  const school = form_.idOrg
  const form = form_.form
  const addschool = form_.addschool
  return {year, school, form, addschool}
}

export const getYearsList = (startYear, endYear) => {
  if (startYear && endYear) {
    const years = [];
    for (let i = startYear; i <= endYear; i++) {
      years.push(i);
    }
    return years;
  }
  const year = new Date().getFullYear();
  return [Number(year) - 1, Number(year), Number(year) + 1];
}

export const getOrgFormattedData = list => list.map(i => ({...i, idorganization: i.idorganization || i.idOrganization}))

